// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
if (!customElements.get('sp-collection-accordion')) {
  customElements.define('sp-collection-accordion', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const details = this.querySelector('details');
      const summary = details.querySelector('summary');
      this.setOpen = (opening) => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) { details.open = opening; return; }
        this.animateOpen(details, summary, opening);
      };
      summary.addEventListener('click', event => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.preventDefault();
        this.setOpen(this.animation ? !this.opening : !details.open);
      }, {signal: this.abort.signal});
    }
    animateOpen(details, summary, opening) {
        const start = details.getBoundingClientRect().height;
        this.animation?.cancel();
        this.opening = opening;
        details.style.height = '';
        details.open = true;
        const end = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        details.style.overflow = 'hidden';
        const animation = details.animate([{height: `${start}px`}, {height: `${end}px`}], {
          duration: 360, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'both'
        });
        this.animation = animation;
        animation.onfinish = () => {
          details.open = opening;
          animation.cancel();
          details.style.overflow = '';
          this.animation = null;
        };
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.animation?.cancel();
      const details = this.querySelector('details');
      if (details) details.style.overflow = '';
    }
  });
}
